import vuetifyToast from 'vuetify-toast'
import { baseActions, baseMutations } from '../base'
import { apiAxios } from '@/helpers'
import { formatDate } from '@/helpers/dateHelper'

const notify = (message) => {
  vuetifyToast.show({
    text: message,
    color: 'success',
    timeout: 2000,
    icon: 'check',
  })
}
const initialState = () => {
  return {
    module: 'phases',
    model: 'phase',
    loading: false,
    list: [],
    selected: {
      active: true,
      order: 0,
      name: [],
      hours: [],
      typePlayOff: 'ranking',
      toClass: 1, // Math.floor(this.toClass / 2),
      matchesByParticipant: 1,
      showResults: false,
      randomMatches: false,
    },
    idSelected: '',
  }
}

const state = initialState()

const getters = {
  formatedList(state) {
    return state.list.map((item) => {
      let result = {
        _id: item._id,
        name: item.name,
        createdAt: formatDate(item.createdAt, true),
        createdBy: item.createdBy
          ? item.createdBy.name + ' ' + item.createdBy.lastname1
          : '-',
      }
      return result
    })
  },
}

const actions = {
  ...baseActions,
  async getOne({ commit, state, rootState }, id) {
    let tournamentId = rootState.tournaments.idSelected
    commit('setLoading', true)
    const { data } = await apiAxios
      .get(`tournaments/${tournamentId}/phases/${id}`)
      .finally(() => commit('setLoading', false))
    const item = data.data ? data.data[state.model] : {}
    return item
  },
  async fetchOne({ commit, dispatch }, id) {
    let item = await dispatch('getOne', id)
    commit('setOne', item)
    return item
  },
  async fetchList({ commit, state, rootState }, params = {}) {
    let tournamentId = rootState.tournaments.idSelected

    commit('setLoading', true)
    const { data } = await apiAxios
      .post(`tournaments/${tournamentId}/phases`, params)
      .finally(() => commit('setLoading', false))

    const list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []
    commit('setList', list)
  },
  async create({ dispatch, commit, state, rootState }, payload) {
    let tournamentId = rootState.tournaments.idSelected
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(`tournaments/${tournamentId}/phases/create`, payload)
      .finally(() => commit('setLoading', false))
    notify(data.message)
    dispatch('tournaments/fetchOne', tournamentId, { root: true })
    // dispatch('fetchList')
    const item = data.data ? data.data[state.model] : {}
    return item
  },
  async update({ dispatch, commit, state, rootState }, payload) {
    let tournamentId = rootState.tournaments.idSelected
    const id = payload._id

    commit('setLoading', true)
    const { data } = await apiAxios
      .put(`tournaments/${tournamentId}/phases/${id}`, payload)
      .finally(() => commit('setLoading', false))
    notify(data.message)
    dispatch('tournaments/fetchOne', tournamentId, { root: true })
    // dispatch('fetchList')
    const item = data.data ? data.data[state.model] : {}
    return item
  },
  async delete({ dispatch, commit, rootState }, id) {
    let tournamentId = rootState.tournaments.idSelected
    commit('setLoading', true)
    const { data } = await apiAxios
      .delete(`tournaments/${tournamentId}/phases/${id}`)
      .finally(() => commit('setLoading', false))
    notify(data.message)
    dispatch('tournaments/fetchOne', tournamentId, { root: true })
    // dispatch('fetchList')
  },
  async setRandomMatches({ dispatch, commit, rootState }, phaseId) {
    let tournamentId = rootState.tournaments.idSelected
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(`tournaments/${tournamentId}/phases/${phaseId}/setRandomMatches`)
      .finally(() => commit('setLoading', false))
    notify(data.message)
    dispatch('tournaments/fetchOne', tournamentId, { root: true })
  },
}

const mutations = {
  ...baseMutations,
  resetState(state) {
    const newState = initialState()
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
    Object.assign(state, newState)
  },
  reset(state) {
    state.selected = initialState().selected
    state.idSelected = ''
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
